import dynamic from "next/dynamic"
import { useAmp } from "next/amp"
import { useStore } from "@features/common"
import { isJournalLocationPathname } from "@lib/history"
import { useOnMount } from "@lib/hooks"

import { LocalStorageFields } from "../subscription.consts"

export function useShowSubscriptionDialog() {
  const isAmp = useAmp()

  const { SubscriptionModel, ModalModel } = useStore()

  const onMount = () => {
    if (isAmp) return
    const { showPopUp, popUpDelay = 30 } = SubscriptionModel

    if (localStorage.getItem(LocalStorageFields.subscriptionPopupShown)) {
      return
    }

    setTimeout(() => {
      if (
        showPopUp &&
        !localStorage.getItem(LocalStorageFields.subscriptionPopupShown) &&
        isJournalLocationPathname()
      ) {
        // @ts-ignore
        const SubscriptionDialog = dynamic(() =>
          import("../organisms").then((mod) => mod.SubscriptionDialog),
        )
        ModalModel.open(<SubscriptionDialog />)
        localStorage.setItem(LocalStorageFields.subscriptionPopupShown, "1")
      }
    }, Number(popUpDelay) * 1000)
  }

  useOnMount(onMount)
}
